var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chatItem"},[_vm._v(" "+_vm._s(_vm.chatItem.nickname)+" "+_vm._s(_vm.chatItem.chatContext)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }